<div class="action-panel meeting-action-panel">
  <div class="action-panel-header">
    <i class="fa fa-check-square-o" style="margin-right:6px;"></i>
    {{ meetingsOrder[MEETING_FORM] | titlecase }} meeting completion
  </div>

  <div class="action-panel-body">
    <p class="action-panel-desc">
      Did you complete the <strong>{{ meetingsOrder[MEETING_FORM] }}</strong> meeting?
    </p>

    <div class="yes-no-row">
      <button (click)="accept(false)" class="btn btn-default action-btn action-btn--secondary">No</button>
      <button (click)="accept(true)"  class="btn btn-primary action-btn">Yes</button>
    </div>
  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
